export const BlacklistAPI = {};

const SLICE = 'blacklist';

BlacklistAPI.create = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/profile/blacklist`,
    method:   'POST',
    data:     data,
    slice:     SLICE,
    action:    'create',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

BlacklistAPI.delete = (ids, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/profile/blacklist`,
    method:    'DELETE',
    data:      {ids},
    slice:     SLICE,
    action:    'delete',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

BlacklistAPI.update = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/profile/blacklist`,
    method:   'PUT',
    data:     data,
    slice:     SLICE,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

BlacklistAPI.list = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/profile/blacklists`,
    method:    'GET',
    data:      data,
    slice:     SLICE,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

BlacklistAPI.item = (id, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/profile/blacklist`,
    method:    'GET',
    data:      {id},
    slice:     SLICE,
    action:    'item',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

BlacklistAPI.search = (field, operator, value, onSuccess, onFailure) => {
  return {
    type: 'API',
    url: `/profile/blacklists`,
    method: 'POST',
    data: {
      field,
      operator,
      value
    },
    slice: SLICE,
    action: 'search',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};
